
/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */

L.Map.mergeOptions({
	// @section Mousewheel options
	// @option scrollWheelZoom: Boolean|String = true
	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	// it will zoom to the center of the view regardless of where the mouse was.
	initBounds: undefined,

	initBoundsFlyToDuration: 1,
	
	initBoundsFlyToEase: 0.1,
	
	initBoundsPadVariation: 0.5
	

});

var InitBounds = L.Handler.extend({
	addHooks: function () {
		this._map.whenReady(this._onLoadMap, this);
	},

	removeHooks: function () {

	},

	_onLoadMap: function (e) {

		var initLatlngbounds = L.latLngBounds(this._map.options.initBounds) 
		if (initLatlngbounds instanceof L.LatLngBounds){
			
			this._map.fitBounds(initLatlngbounds.pad(this._map.options.initBoundsPadVariation));
					this._map.once(
						'alltilesload',
						function() {
							setTimeout(
									function(handler) {
										handler._map.flyToBounds(
											L.latLngBounds(handler._map.options.initBounds),
											{
												paddingTopLeft : L.point(10,10),
												paddingBottomRight : L.point(10,10),
												duration : handler._map.options.initBoundsFlyToDuration,
												easeLinearity : handler._map.options.initBoundsFlyToEase,
												animate : true,
												maxZoom : handler._map.options.maxZoom
											});
									}, 
									500, 
									this);
	
						}, this);			
		}		

		L.DomEvent.stop(e);
	},


});

// @section Handlers
// @property InitBounds: Handler
// Scroll wheel zoom handler.
L.Map.addInitHook('addHandler', 'initBounds', InitBounds);
